import siblingElements from '@/js/helpers/sibling-elements'

export default class Accordion {
    constructor(element) {
        this.component = element
        this.items = [...element.getElementsByClassName('js-accordion-item')]
        this.groupedName = element.dataset.group
        this.currentItem = null
        this.activeClass = 'js-active'
        this.openCloseModeClass = 'js-open-close'
        this.matchMedia = '(min-width: 960px)'

        this.init()
    }

    stringToBool(str) {
        return str === 'true'
    }

    init() {
        this.addListeners()
        this.scrollToAccordion()
    }

    addListeners() {
        this.items.forEach(item => {
            const button = item.querySelector('.js-accordion-button')

            if (item.classList.contains(this.activeClass)) {
                setTimeout(() => {
                    this.toggleItemHeight(item)
                }, 500)
            }

            this.toggleAria(item, true)
            button.addEventListener('click', this.onToggle.bind(this, item), false)
        })

        window.addEventListener('resize', () => {
            if (this.currentItem) {
                this.heightResizeHandler(this.currentItem)
            }
        })
    }

    onToggle(currentItem) {
        const otherAccordionItems = this.checkForGroups(siblingElements(currentItem))

        if (!this.component.classList.contains(this.openCloseModeClass)) {
            otherAccordionItems.forEach(item => {
                this.toggleItemClass(item, true)
                this.toggleItemHeight(item, true)
                this.toggleAria(item, true)
            })
        }

        this.currentItem = currentItem
        this.toggleItemClass(currentItem)
        this.toggleItemHeight(currentItem)
        this.toggleAria(currentItem)
    }

    toggleAria(item, remove = false) {
        const button = item.querySelector('.js-accordion-button')
        const content = item.querySelector('.js-accordion-content')

        const isButtonExpanded = button.getAttribute('aria-expanded')
        const isContentHidden = content.getAttribute('aria-hidden')

        button.setAttribute('aria-expanded', remove ? false : !this.stringToBool(isButtonExpanded))
        content.setAttribute('aria-hidden', remove ? true : !this.stringToBool(isContentHidden))
    }

    toggleItemClass(item, remove = false) {
        if (remove) {
            item.classList.remove(this.activeClass)
            return
        } else item.classList.toggle(this.activeClass)
    }

    toggleItemHeight(item, remove = false) {
        const content = item.querySelector('.js-accordion-content')

        if (remove) {
            content.style.height = null
            this.currentItem = null
            return
        }

        const contentHeight = content.firstElementChild.clientHeight
        const contentIsClosed = content.style.height === '0px' || !content.style.height

        content.style.height = contentIsClosed ? `${contentHeight + 2}px` : null
        this.currentItem = contentIsClosed ? item : null
    }

    heightResizeHandler(item) {
        const content = item.querySelector('.js-accordion-content')

        const contentHeight = content.firstElementChild.clientHeight

        content.style.height = `${contentHeight + 2}px`

        if (window.matchMedia(this.matchMedia).matches) {
            content.style.height = 'auto'
        } else {
            item.classList.remove(this.activeClass)
            content.style.height = 0
        }
    }

    checkForGroups(siblingItems) {
        if (!this.groupedName) return siblingItems

        const otherGroups = Array.from(
            document.querySelectorAll(`.js-accordion[data-group="${this.groupedName}"]`),
        ).filter(group => group !== this.component)

        if (!otherGroups.length) return siblingItems

        const groupItems = otherGroups.reduce((acc, group) => {
            const items = Array.from(group.querySelectorAll('.js-accordion-item'))
            return [...acc, ...items]
        }, [])

        return [...groupItems, ...siblingItems]
    }

    scrollToAccordion() {
        const [...linkToAccordion] = document.querySelectorAll('.anchor-to-accordion')

        linkToAccordion.forEach(elem => {
            elem.addEventListener('click', () => {
                const linkHref = elem.getAttribute('href').replace(/#/g, '')

                this.items.forEach(item => {
                    if (linkHref === item.id) {
                        this.onToggle(item)
                    }
                })
            })
        })
    }
}
